import {InboundBridgeBucketRecord} from './index';
import {Box, Container, Header, PieChart, Spinner} from '@amzn/awsui-components-react';
import React from 'react';

const COMPONENT_TEXTS = {
    chart_title: 'Aggregated WAPE Contributions',
    chart_description:
        'The Weighted Absolute Percentage Error (WAPE) contribution metrics have been normalized to align with the total WAPE. Top 10 biggest contributors are shown.',
} as const;

export function InboundBridgePieChart({data, isLoading}: {data: InboundBridgeBucketRecord[]; isLoading: boolean}) {
    if (isLoading) {
        return (
            <Container header={<Header variant="h2">{COMPONENT_TEXTS.chart_title}</Header>}>
                <Box textAlign="center" color="inherit">
                    <Spinner size="large" />
                </Box>
            </Container>
        );
    }

    const chartData = transformData(data);

    return (
        <Container
            header={
                <Header variant="h2" description={COMPONENT_TEXTS.chart_description}>
                    {COMPONENT_TEXTS.chart_title}
                </Header>
            }
        >
            <PieChart
                data={chartData}
                variant="donut"
                size="large"
                legendTitle="Bucket"
                innerMetricDescription="Top contributors"
                hideFilter={true}
                empty={
                    <Box color="inherit" textAlign="center">
                        <Box fontWeight="bold">No data available</Box>
                        <Box color="inherit" variant="p">
                            There is no WAPE contribution data for the selected filters.
                        </Box>
                    </Box>
                }
                noMatch={
                    <Box color="inherit" textAlign="center">
                        <Box fontWeight="bold">No matching data</Box>
                        <Box color="inherit" variant="p">
                            There is no data matching your filter criteria.
                        </Box>
                    </Box>
                }
            />
        </Container>
    );
}

export function transformData(records: InboundBridgeBucketRecord[]): {title: string; value: number}[] {
    if (records.length === 0) {
        return [];
    }

    return records
        .filter((record) => record.wapeContribRescaled !== undefined && record.wapeContribRescaled > 0)
        .sort((a, b) => b.wapeContribRescaled! - a.wapeContribRescaled!)
        .slice(0, 10)
        .map((record) => ({
            title: record.name,
            value: record.wapeContribRescaled!,
        }));
}
